module.exports = __webpack_public_path__ + "static/media/ecu.3ee011a4.svg";